'use strict';

angular.module('pmtPlacesApp.controllers').controller('ClaimFacebookDiscardCtrl', [
	'$scope',
	'$stateParams',
	'$http',
	function ($scope, $stateParams, $http) {
		let site = $stateParams.site;
		$scope.site = site;
		$scope.places = [];

		let reMapDataObject = function (discardObject) {
			let addMapConfig = function (discardItem) {
				discardItem.mapConfiguration = {
					location: discardItem.data.location,
					iconType: 'facebook'
				};
				return discardItem;
			};

			let reMapedData = discardObject.map(function (discardItem) {
				let place = discardItem.item;
				place.mapConfiguration = {
					location: place.location,
					iconType: 'pinmeto'
				};
				place.discardItem = addMapConfig(discardItem.discardedItem);

				return place;
			});

			return reMapedData;
		};

		$http.get('api/' + site + '/facebook/claim/discardlist').then(function (res) {
			$scope.places = reMapDataObject(res.data.data);
		});

		$scope.removeFormList = function (place, result) {
			$http
				.delete(
					'api/' +
						site +
						'/place/' +
						place._id +
						'/facebook/existingpage/discard/' +
						result.facebookId
				)
				.then(function (/*res*/) {
					$scope.places = $scope.places.filter(function (p) {
						return p !== place;
					});
				});
		};
	}
]);
